<template>
  <div>
    <!-- tab开始 -->
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane
        :label="'全部 ' + '(' + pageConfig.total + ')'"
        name="0"
      ></el-tab-pane>
      <el-tab-pane
        :label="
          '待拣货 ' +
          '(' +
          ((tableData[0] && tableData[0].waitPickQty) || 0) +
          ')'
        "
        name="10"
      ></el-tab-pane>
      <el-tab-pane
        :label="
          '生成装车 ' +
          '(' +
          ((tableData[0] && tableData[0].loadCarQty) || 0) +
          ')'
        "
        name="15"
      ></el-tab-pane>
      <el-tab-pane
        :label="
          '拣货中 ' +
          '(' +
          ((tableData[0] && tableData[0].pickingQty) || 0) +
          ')'
        "
        name="20"
      ></el-tab-pane>
      <el-tab-pane
        :label="
          '待出库 ' +
          '(' +
          ((tableData[0] && tableData[0].waitOutQty) || 0) +
          ')'
        "
        name="30"
      ></el-tab-pane>
      <el-tab-pane
        :label="
          '部分出库 ' +
          '(' +
          ((tableData[0] && tableData[0].partOutQty) || 0) +
          ')'
        "
        name="35"
      ></el-tab-pane>
      <el-tab-pane
        :label="
          '全部出库 ' +
          '(' +
          ((tableData[0] && tableData[0].allOutQty) || 0) +
          ')'
        "
        name="40"
      ></el-tab-pane>
      <el-tab-pane
        :label="
          '取消 ' + '(' + ((tableData[0] && tableData[0].cancelQty) || 0) + ')'
        "
        name="99"
      ></el-tab-pane>
    </el-tabs>
    <!-- tab结束 -->
    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @resetBtn="resetBtn"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:orgIds>
        <el-select
          multiple
          filterable
          v-model="filters.OrgIds"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in organizationList"
            :label="item.customName"
            :value="item.organizationId"
            :key="item.organizationId"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:warehouseIDs>
        <el-select
          multiple
          filterable
          v-model="filters.WarehouseIDs"
          placeholder="请选择仓库"
          collapse-tags
        >
          <el-option
            v-for="item in warehouseList"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:status>
        <selectAllVue
          :selectOptions="statuslist"
          :mulSelecteds="filters.status"
          @update:updateMultipleSelect="(val) => (filters.status = val)"
        />
        <!-- <el-select
          multiple
          filterable
          v-model="filters.status"
          placeholder="请选择状态"
        >
          <el-option
            v-for="item in statuslist"
            :label="item.outboundText"
            :value="item.outboundId"
            :key="item.outboundId"
          ></el-option>
        </el-select> -->
      </template>
      <template v-slot:tdate>
        <el-select
          class="dateSelect"
          v-model="filters.DateType"
          placeholder="请选择"
        >
          <el-option
            v-for="item in DateTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          v-model="filters.tdate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>

      <template slot-scope="scope" slot="outboundNo">
        <hoverCopy>
          <el-link
            slot="referenceChild"
            :underline="false"
            type="primary"
            @click.native="viewloadingReviewdialog(scope.row)"
            >{{ scope.row.outboundNo }}
          </el-link>
        </hoverCopy>
      </template>
      <template slot-scope="scope" slot="file">
        <div>
          <span>备柜照片:</span>
          <span v-if="scope.row.isPicking > 0">
            <el-link
              :underline="false"
              type="primary"
              @click.native="getReadyImages(scope.row.tfOutboundID,1)"
            >
              预览
            </el-link>
            <el-link
              style="margin-left: 5px"
              :underline="false"
              type="primary"
              @click.native="handleImages(scope.row.tfOutboundID,1)"
            >
              下载
            </el-link>
          </span>
          <br />
          <span>装车照片:</span>
          <span v-if="scope.row.isLoading > 0">
            <el-link
              :underline="false"
              type="primary"
              @click.native="getReadyImages(scope.row.tfOutboundID,2)"
            >
              预览
            </el-link>
            <el-link
              style="margin-left: 5px"
              :underline="false"
              type="primary"
              @click.native="handleImages(scope.row.tfOutboundID,2)"
            >
              下载
            </el-link>
          </span>
          <br />
        </div>
      </template>
      <template slot-scope="scope" slot="abnormal">
        <div>
          <span v-if="scope.row.isAbnormal == true" style="color: red">
            {{ scope.row.isAbnormalText }}
          </span>
          <span v-else> {{ scope.row.isAbnormalText }}</span>
        </div>
      </template>
     
       <template v-slot:realName>
        <el-select multiple v-model="filters.realName" filterable placeholder="请选择" collapse-tags>
          <el-option
            v-for="item in userList"
            :label="item.realName"
            :value="item.realName"
            :key="item.realName"
          ></el-option>
        </el-select>
      </template>
    </TwTable>
    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{ businessType: 36, businessCode: currentRow.outboundNo }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    ></LogDialog>
    <!-- 装车单 -->
    <el-dialog
      id="completeDialog"
      title="出库单"
      :visible.sync="addTaskdialogVisible"
      width="90%"
      top="70px"
      style="text-align: center"
    >
      <div id="completeDiv">
        <iframe
          :src="completeTask"
          height="700"
          width="100%"
          style="border: none"
        ></iframe>
      </div>
    </el-dialog>

    <!-- 打印拣货单 -->
    <el-dialog
      :visible.sync="printPickListVisible"
      v-model="printPickListVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      class="printDalog"
      title="打印拣货单"
      width="70%"
      style="text-align: center"
    >
      <el-row type="flex" class="row-bg printRow" justify="end">
        <div class="print">
          <el-button type="primary" v-print="'#printMe'" @click="printPick()"
            >打印</el-button
          >
        </div>
      </el-row>

      <div id="printMe" ref="printContent">
        <div style="margin-bottom: 12px">
          <img id="barcode1" />
        </div>
        <div class="printList">
          <el-row type="flex" class="row-bg">
            <el-col :span="6"
              ><div class="grid-content bg-purple">
                <strong>出库参考单号:{{ outbountPrint.orgOutboundNo }}</strong>
              </div></el-col
            >
            <el-col :span="5"
              ><div class="grid-content bg-purple">
                <strong>联系人:{{ outbountPrint.driver }}</strong>
              </div></el-col
            >
            <el-col :span="5"
              ><div class="grid-content bg-purple">
                <strong>联系电话：{{ outbountPrint.driverPhone }}</strong>
              </div></el-col
            >
            <el-col :span="5"
              ><div class="grid-content bg-purple">
                <strong>车牌号：{{ outbountPrint.carNumber }}</strong>
              </div></el-col
            >
            <el-col :span="8"
              ><div class="grid-content bg-purple">
                 <strong
                  >箱数/体积/重量：{{ outbountPrint.boxCount }}件/{{
                    outbountPrint.volume
                  }}CMB/{{ outbountPrint.grossWeight }}KG</strong
                >
              </div></el-col
            >
          </el-row>
        </div>

        <el-table
          :data="boxPrint"
          highlight-current-row
          border
          style="
            width: 100%;
            border: 1px solid #000;
            border-right: initial !important;
          "
          class="printTable"
          :row-style="{ height: '0' }"
          :cell-style="{ padding: '0' }"
        >
          <el-table-column prop="orgReceiptNo" minWidth="130" label="进仓单号">
          </el-table-column>
          <el-table-column prop="orgCustomerNo" minWidth="130" label="参考单号">
          </el-table-column>
          <el-table-column prop="destination" minWidth="100" label="目的地"></el-table-column>
          <el-table-column prop="storages" minWidth="110" label="库位"></el-table-column>
          <el-table-column prop="feeTypeName" minWidth="60" label="增值服务"></el-table-column>
          <el-table-column prop="orgBoxCount" minWidth="60" label="箱数"></el-table-column>
          <el-table-column prop="boxVolumn" minWidth="60" label="总体积"></el-table-column>
          <el-table-column prop="boxWeight" minWidth="60" label="总重量"></el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 打印装车单 -->
    <el-dialog
      :visible.sync="printLoadListVisible"
      v-model="printLoadListVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="打印装车单"
      :width="'400mm'"
      :height="'250mm'"
      style="text-align: center"
    >
      <el-row>
        <div class="print" style="float: right">
          <el-button
            type="primary"
            v-print="'#printLoad'"
            @click="printLoadCar()"
            >打印</el-button
          >
        </div>
      </el-row>
      <div id="printLoad" ref="printContent">
        <div v-html="styleText"></div>
        <div>
          <el-row type="flex" class="row-bg printTitle">
            <el-col :span="8"
              ><div class="grid-content bg-purple" style="text-align: left">
                <strong
                  >单号:{{ carInfoPrint.outboundNo }}({{
                    carInfoPrint.orgOutboundNo
                  }})</strong
                >
              </div></el-col
            >
            <el-col :span="6"
              ><div class="grid-content bg-purple" style="text-align: left">
                <strong>预计装柜：{{ carInfoPrint.deliveryDateDesc }}</strong>
              </div></el-col
            >
            <el-col :span="8"
              ><div class="grid-content bg-purple" style="text-align: left">
                <strong
                  >箱数/体积/重量：{{ carInfoPrint.boxCount }}件/{{
                    carInfoPrint.volume
                  }}CMB/{{ carInfoPrint.grossWeight }}KG</strong
                >
              </div></el-col
            >
          </el-row>
          <el-row type="flex" class="row-bg printTitle">
            <el-col :span="8"
              ><div class="grid-content bg-purple" style="text-align: left">
                <strong
                  >柜号/柜型：{{ carInfoPrint.containerNumber }}/{{
                    carInfoPrint.containerType
                  }}
                </strong>
              </div></el-col
            >
            <el-col :span="6"
              ><div class="grid-content bg-purple" style="text-align: left">
                <strong
                  >SO:{{ carInfoPrint.soNumber }}
                  {{ carInfoPrint.transportType }}
                </strong>
              </div></el-col
            >
            <el-col :span="8"
              ><div class="grid-content bg-purple" style="text-align: left">
                <strong
                  >司机信息：{{ carInfoPrint.carNumber }}/{{
                    carInfoPrint.driver
                  }}/{{ carInfoPrint.driverPhone }}</strong
                >
              </div></el-col
            >
          </el-row>
        </div>
        <PrintTable :data="carBoxPrint" :columns="carBoxColumns">
          <template slot-scope="scope" slot="skuCode">
            {{ scope.row.skuCode.split("/")[0] }}<br />
            /{{ scope.row.skuCode.split("/")[1] }}
          </template>
        </PrintTable>
      </div>
    </el-dialog>

    <!-- 预览图片 -->
    <div>
      <viewer :images="srcList" class="viewer" ref="viewer" @inited="inited">
        <img v-for="(src, index) in srcList" :src="src" :key="index" />
      </viewer>
    </div>
    <el-dialog
      id="loadingReviewdialog"
      :title="loadingReviewdialogTitle"
      :close-on-click-modal="false"
      :visible.sync="loadingReviewdialogVisible"
      class="dialogClass"
      style="text-align: center; overflow-y: hidden"
      :fullscreen="true"
    >
      <div id="completeDivd">
        <OutboundOrderSend
          v-if="loadingReviewdialogVisible"
          :outboundNoDalog="outboundNoDalog"
          @searchTable="
            () => {
              initTable();
            }
          "
          @cancelDalog="loadingReviewdialogVisible = false"
          :viewtypeDalog="viewtypeDalog"
        />

        <!-- <iframe
          :src="loadingReviewWinodw"
          width="100%"
          :height="loadingReviewWinodwheight"
          frameborder="0"
          style="overflow-x: hidden"
        ></iframe> -->
      </div>
    </el-dialog>

    <!--  -->
    <el-dialog
      title="完成拣货"
      :visible.sync="pickingOverVisible"
      v-model="pickingOverVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      width="30%"
    >
      <el-form
        :model="pickingOverForm"
        ref="pickingOverForm"
        label-width="100px"
      >
        <el-card shadow="hover" style="width: 100%">
          <el-row>
            <el-col :span="24">
              <el-form-item label="出库单号：" prop="outboundNo">
                <el-input
                  v-model="pickingOverForm.OutboundNo"
                  auto-complete="off"
                  :readonly="true"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="库位" prop="storages">
                <!-- <el-input
                  v-model="pickingOverForm.Storages"
                  auto-complete="off"
                  placeholder="请输入库位"
                  maxlength="50"
                ></el-input> -->
                <el-select
                  v-model="pickingOverForm.Storages"
                  style="width: 200px"
                  placeholder="请选择库位"
                  multiple
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in locationList"
                    :label="item.locationCode"
                    :value="item.locationCode"
                    :key="item.locationCode"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

        <el-card shadow="hover" style="margin-top: 10px; width: 100%">
          <div style="text-align: center">
            <el-button type="primary" @click="pickingOverSubmit"
              >提交</el-button
            >
            <el-button @click="pickingOverVisible = false">取消</el-button>
          </div>
        </el-card>
      </el-form>
    </el-dialog>

    <!-- 打托操作 -->
    <el-dialog
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="打托"
      width="30%"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addRuleForm"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="出库单号"
              prop="OutboundNo"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.OutboundNo"
                auto-complete="off"
                maxlength="50"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

           
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="已打托总箱数"
              prop="PalletBoxCount"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.PalletBoxCount"
                auto-complete="off"
                maxlength="50"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item
              label="箱数"
              prop="BoxCount"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.BoxCount"
                auto-complete="off"
                placeholder="请输入箱数"
                type="number"
                min="0"
                @input="
                  addForm.BoxCount = addForm.BoxCount.replace(
                    /^(0+)|[^\d]+/g,
                    ''
                  )
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item
              label="库位"
              class="labelcall"
              label-width="120px"
              prop="Storages"
            >
              <el-select
                v-model="addForm.Storages"
                style="width: 100%"
                placeholder="请选择库位"
                clearable
                filterable
              >
                <el-option
                  v-for="item in locationList"
                  :label="item.locationCode"
                  :value="item.locationCode"
                  :key="item.locationCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="打托数"
              prop="PalletQty"
              class="labelcall"
              label-width="120px"
            >
              <template slot="label">
                打托数
                <el-tooltip effect="dark" placement="top">
                  <div slot="content" style="width: 310px">
                    每托打托箱数相同、堆放库位相同时，可直接录入打托数量
                  </div>
                  <i class="el-icon-question" />
                </el-tooltip>
              </template>
              <el-input
                v-model="addForm.PalletQty"
                auto-complete="off"
                placeholder="请输入打托数"
                type="number"
                min="0"
                @input="
                  addForm.PalletQty = addForm.PalletQty.replace(
                    /^(0+)|[^\d]+/g,
                    ''
                  )
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row type="flex" class="row-bg" justify="end">
          <el-button @click="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click="onAddSubmit" :loading="addLoading"
            >打托</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
    <!-- 出库单详情 -->
    <OutboundOrderDetailDalog
      ref="OutboundOrderDetailDalog"
    ></OutboundOrderDetailDalog>
  </div>
</template>
<script>
import {
  getOutboundOrderAsync,
  getOutboundReviewImages,
  getOutboundReviewImagesFileOut,
  getOutboundOrderPrint,
  outboundOrderStatusPrint,
  outboundBind,
  outboundOverPicking,
  getAreaLocation,
  JudgeOutboundInfoIsAbnormal,
  addTFPallet,
  exportTFOutboundAsync,
  exportTFOutboundBoxAsync,
  getLoadInfoPrint,
  exportTFOutboundPickAsync,
} from "@/api/outbound/outboundOrder.js";
import JsBarcode from "jsbarcode";
import { getReadyforTaskBasis } from "@/api/outbound/readyforTask.js";
import { getButtonList } from "../../promissionRouter";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import axios from "axios";
import { thereAre } from "util/util";
import LogDialog from "../../components/TwTable/components/logDialog";
import { GetContainerTypeList } from "@/api/common/common.js";
import OutboundOrderSend from "./OutboundOrderSend.vue";
import html2canvas from "html2canvas";
import printJS from "print-js";
import OutboundOrderDetailDalog from "./OutboundOrderDetailDalog.vue";
import selectAllVue from "../../components/TwTable/selectAll.vue";
import hoverCopy from "./../../components/hoverCopy.vue";
import PrintTable from "../../components/printTable.vue";
import {getOperatorInfo} from "@/api/api.js";

export default {
  components: {
    LogDialog,
    TwTable,
    OutboundOrderSend,
    OutboundOrderDetailDalog,
    selectAllVue,
    hoverCopy,
    PrintTable,
  },
  mixins: [TwTable_mixins],
  data() {
    return {
      styleText:
        '<style type="text/css" media="print">\n' +
        "  @page { size: landscape; }\n" +
        "</style>",
      activeName: "0",
      outboundNoDalog: "",
      viewtypeDalog: "",
      DateTypeOptions: [
        {
          value: "a.CreateTime",
          label: "创建时间",
        },
        {
          value: "a.DeliveryDate",
          label: "预计发货时间",
        },
        {
          value: "a.ActDeliveryDate",
          label: "实际发货时间",
        },
      ],
      printObj: {
        id: "printMe",
        popTitle: "拣货单",
        extraCss: "https://www.google.com,https://www.google.com",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
      },
      tableConfig: {
        showResetButton: true,
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: true, // 显示操作栏
        operate: {
          //操作栏配置
          align: "center",
          options: [
            {
              name: "查看日志",
              size: "small",
              type: "text",
              event: "getbusinessLoglist", // 操作的事件名
            },
          ],
        },
        column: [
          // 表格列配置

          {
            prop: "outboundNo",
            label: "出库单号",
            align: "center",
            sortable: true,
            minWidth: "160",
            slot: true,
          },
          {
            prop: "orgOutboundNo",
            label: "参考单号",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "customName",
            label: "客户",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
           {
            prop: "createUser",
            label: "创建人",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "warehouseName",
            label: "仓库",
            align: "center",
            sortable: true,
            minWidth: "110",
          },
          {
            prop: "outboundStatusText",
            label: "状态",
            align: "center",
            sortable: true,
            minWidth: "120",
          },

          {
            prop: "boxCount",
            label: "预发箱数",
            align: "center",
            sortable: true,
            minWidth: "110",
          },
          {
            prop: "receivedBoxVolume",
            label: "体积",
          },
          {
            prop: "receivedBoxWeight",
            label: "重量",
          },
          {
            prop: "sendBoxCount",
            label: "实发箱数",
            align: "center",
            sortable: true,
            minWidth: "110",
          },
          {
            label: "物流信息",
            minWidth: "220",
            formatter: function (val, row) {
              return (
                "<span>运输方式:" +
                (row.transportType || "") +
                "</span><br /><span>SO号:" +
                (row.soNumber || "") +
                "</span><br /> <span>柜号:" +
                (row.containerNumber || "") +
                "</span><br />"
              );
            },
          },
          {
            label: "司机信息",
            minWidth: "200",
            formatter: function (val, row) {
              return (
                "<span>车牌号:" +
                (row.carNumber || "") +
                "</span><br /> <span>司机:" +
                (row.driver || "") +
                "</span><br /><span>电话:" +
                (row.driverPhone || "") +
                "</span><br />"
              );
            },
          },
          {
            label: "操作节点",
            minWidth: "220",
            formatter: function (val, row) {
              return (
                "<span>创建时间:" +
                (row.createTime || "") +
                "</span><br /><span>预计发货:" +
                (row.deliveryDate || "") +
                "</span><br />"
              );
            },
          },
          {
            prop: "file",
            label: "附件",
            slot: true,
            minWidth: "150",
          },
          {
            prop: "remark",
            label: "备注",
            align: "center",
            sortable: true,
            minWidth: "90",
          },
        ],
      },
      loadingReviewWinodw: "",
      loadingReviewWinodwheight: 800,
      loadingReviewdialogVisible: false,
      organizationList: [], //客户货主
      searchData: {
        //搜索列配置

        search: [
          {
            type: "input",
            key: "documentNos",
            label: "单据号",
            placeholder: "出库单号/参考单号",
            clearable: true,
            width: 200,
          },
          {
            type: "input",
            key: "deliveryOrdeNo",
            label: "进仓单号",
            placeholder: "进仓单号",
            clearable: true,
            width: 200,
          },
          {
            type: "select",
            key: "warehouseIDs",
            prop: "warehouseIDs",
            label: "仓库",
            multiple: true,
            slot: true,
            placeholder: "请选择仓库",
            option: this.warehouseList,
          },
          {
            type: "select",
            key: "orgIds",
            prop: "orgIds",
            label: "客户货主",
            multiple: true,
            slot: true,
            placeholder: "请选择客户货主",
            option: this.organizationList,
          },
        ],
        ///高级搜索配置
        moreSearch: [
          {
            type: "select",
            key: "status",
            prop: "status",
            label: "状态",
            multiple: true,
            slot: true,
            placeholder: "请选择状态",
            option: this.statuslist,
          },
          {
            key: "tdate",
            prop: "tdate",
            slot: true,
            label: "创建时间",
            hideLabel: true,
          },
          {
            type: "select",
            key: "realName",
            prop: "realName",
            label: "操作人",
            multiple: true,
            slot: true,
            placeholder: "",
            option: this.userList,
          },
        ],
      },
      buttonList: [],

      //-------------
      warehouseList: [],
      transportList: [],
      locationList: [],
      statuslist: [],
      srcList: [],
      addTaskdialogVisible: false,
      outbountPrint: {},
      boxPrint: [],
      printPickListVisible: false,
      printLoadListVisible: false,
      pickingOverVisible: false,
      pickingOverForm: {},
      ContainerTypeList: [],
      carInfoPrint: {},
      carBoxPrint: [],
      completeTask: "",
      loadingReviewdialogTitle: "装车单详情",
      //打托
      addFormVisible: false,
      addLoading: false,
      addForm: {
        SourceId: 0,
        OutboundNo: "",
        BoxCount: "",
        PalletQty: 1,
        Storages: "",
        PalletBoxCount: 0,
      },
      carBoxColumns: [
        {
          slot: true,
          prop: "skuCode",
          label: "SKU/调入SKU",
          minWidth: "150",
        },
        {
          prop: "containerNo",
          label: "临柜号",
          minWidth: "80",
        },
        {
          prop: "markHead",
          label: "唛头",
          minWidth: "100",
        },
        {
          prop: "quantity",
          label: "单箱",
          minWidth: "40",
        },
        {
          prop: "actualBoxVolume",
          label: "体积",
          minWidth: "60",
        },
        {
          prop: "actualBoxWeight",
          label: "重量",
          minWidth: "60",
        },
        {
          prop: "boxNo",
          label: "箱号",
          minWidth: "50",
        },
        {
          prop: "boxCount",
          label: "件数",
          minWidth: "40",
        },
        {
          prop: "actualCount",
          label: "实发件数",
          minWidth: "330",
        },
        {
          prop: "remark",
          label: "仓库备注",
          minWidth: "100",
        },
      ],
      addFormRules: {
        BoxCount: [
          {
            required: true,
            message: "请输入正确的箱数",
            trigger: "blur",
            //pattern: /^[+]?[0-9]?$/,
          },
        ],
        PalletQty: [
          {
            required: true,
            message: "请输入正确的打托数",
            trigger: "blur",
            //pattern: /^[+]?[0-9]?$/,
          },
        ],
        Storages: [
          {
            required: true,
            message: "请输入选择库位",
            trigger: "blur",
            //pattern: /^[+]?[0-9]?$/,
          },
        ],
      },
    };
  },

  created() {
    this.filters.DateType = "a.CreateTime";
    // 监听子组件的关闭事件
    window.addEventListener(
      "message",
      () => {
        this.closeSelf();
        this.closeReviewdialogVisible();
      },
      false
    );
  },
  methods: {
    handleClick(tab, event) {
      let searchDeep = JSON.parse(JSON.stringify(this.searchData.search));
      searchDeep.forEach((item) => {
        if (item.key == "status" && this.activeName !== "0") {
          item.hide = true;
        } else {
          item.hide = false;
        }
      });
      this.filters.status =
        this.activeName == "0" ? "" : this.activeName.split(",");
      this.$set(this.searchData, "search", searchDeep);
      this.initTable();
    },
    toImg() {
      // 转图片打印
      html2canvas(this.$refs.printContent, {
        backgroundColor: null,
        useCORS: true,
        windowHeight: document.body.scrollHeight,
      }).then((canvas) => {
        // let url = canvas.toDataURL('image/jpeg', 1.0)
        const url = canvas.toDataURL();
        this.img = url;
        printJS({
          printable: url,
          type: "image",
          documentTitle: "打印装车单",
          style: "@page {margin:0 10mm};",
        });
        console.log(url);
      });
    },
    inited(viewer) {
      this.$viewer = viewer;
    },
    closeReviewdialogVisible() {
      // 关闭当前弹框
      this.loadingReviewdialogVisible = false;

      this.initTable();
    },
    addBoxMark(loadCarInfoID) {
      var random = Math.random();
      this.completeTask =
        "/Outbound/AddLoadingOrder?random=" +
        random +
        "&type=2&loadCarInfoID=" +
        loadCarInfoID;
      this.addTaskdialogVisible = true;
    },
    // 弹出添加出库单
    addTaskdialog() {
      this.completeTask = "/Outbound/AddOutboundOrder";
      this.addTaskdialogVisible = true;
    },
    // 弹出修改出库单
    editTaskdialog() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }

      if (this.selectRows.rows[0].outboundStatus != 10 && this.selectRows.rows[0].outboundStatus != 20) {
        this.$message({
          message: "完成拣货后不允许修改",
          type: "error",
        });
        return;
      }

      let tfOutboundID = row[0].tfOutboundID;
      JudgeOutboundInfoIsAbnormal({ tfOutboundID: tfOutboundID }).then(
        (res) => {
          console.log(res);

          if (res.data.success) {
            var random = Math.random();
            this.completeTask =
              "/Outbound/AddOutboundOrder?random=" +
              random +
              "&tfOutboundID=" +
              tfOutboundID;
            this.addTaskdialogVisible = true;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        }
      );
    },
    closeSelf() {
      // 关闭当前弹框
      this.addTaskdialogVisible = false;
      this.initTable();
    },
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
    resetBtn() {
      this.filters = {
        DateType: "a.CreateTime",
      };
      this.$set(this.filters, "status", []);
    },
    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },

    viewloadingReviewdialog(rowData) {
      this.$refs.OutboundOrderDetailDalog.showDialog(rowData);
    },
    bindOut() {
      let row = this.selectRows.rows;
      if (row == null || row.length != 2) {
        this.$message({
          message: "请选择两条关联的数据！",
          type: "error",
        });
        return;
      }
      const tfOutboundIDs = this.selectRows.rows.map(r => r.tfOutboundID).join(',');
      outboundBind({ tfOutboundIDs: tfOutboundIDs }).then(
        (res) => {
          if (res.data.success) {
            this.$message({
                message: "操作成功",
                type: "success",
              });
            this.initTable();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        }
      );

      return;
    },
    outboundOverSend() {
      this.loadingReviewdialogTitle = "确认出库";
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      if (this.selectRows.rows[0].outboundStatus != 30) {
        this.$message({
          message: "请选择状态是[待出库]的数据！",
          type: "error",
        });
        return;
      }
      this.$router.push({
        path: "/Outbound/OutboundOrderSendScan",
        query: {
          outboundNo: row[0].outboundNo,
        },
      });
      return;
    },
    //查询列表
    initTable() {
      const {
        WarehouseIDs,
        status,
        documentNos,
        deliveryOrdeNo,
        OrgIds,
        tdate,
        DateType,
        realName,
      } = this.filters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        documentNos,
        deliveryOrdeNo,
        WarehouseIDs: thereAre(WarehouseIDs),
        OrgIds: thereAre(OrgIds),
        realName:thereAre(realName),
        OutboundStatus: status && status.join(",").replace("全选,", ""),
        DateType,
      };

      if (tdate != null && tdate != "null" && tdate != "") {
        para.StartDate = tdate[0];
        para.EndDate = tdate[1];
      }

      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      getOutboundOrderAsync(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },
    //导出
    handleExport() {
      const {
        WarehouseIDs,
        status,
        documentNos,
        deliveryOrdeNo,
        OrgIds,
        tdate,
        DateType,
      } = this.filters;
      let para = {
        page: 1,
        pageSize: 60001,
        documentNos,
        deliveryOrdeNo,
        WarehouseIDs: thereAre(WarehouseIDs),
        OrgIds: thereAre(OrgIds),
        OutboundStatus: status && status.join(",").replace("全选,", ""),
        DateType,
      };
      if (tdate != null && tdate != "null" && tdate != "") {
        para.StartDate = tdate[0];
        para.EndDate = tdate[1];
      }

      this.exportFile(exportTFOutboundAsync, para);
    },
    //导出箱
    handleBoxExport() {
      let row = this.selectRows.rows;
      if (row == null || row.length != 1) {
        this.$message({
          message: "请选择一条出库单！",
          type: "error",
        });
        return;
      }

      let para = {
        tfOutboundID: row[0].tfOutboundID,
      };

      this.exportFile(exportTFOutboundBoxAsync, para);
    },
    
    //导出拣货单
    handlePickExport() {
      let row = this.selectRows.rows;
      if (row == null || row.length != 1) {
        this.$message({
          message: "请选择一条出库单！",
          type: "error",
        });
        return;
      }

      let para = {
        tfOutboundID: row[0].tfOutboundID,
      };

      this.exportFile(exportTFOutboundPickAsync, para);
    },

    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },

    //预览图片
    getReadyImages(id,picType) {
      const data = {
        outboundID: id,
        picType:picType
      };
      //this.showPreviewImg = false;
      this.srcList = [];

      const loading = this.$loading({
        lock: true,
        text: "图片加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      getOutboundReviewImages(data).then((res) => {
        loading.close();
        if (res.data.status === 200 && res.data.success) {
          const { response } = res.data;
          response.forEach((item, i) => {
            response[i] = `data:image/png;base64,${item}`;
          });
          this.srcList = response;
          this.$viewer.view(0);
          this.$viewer.show();
        } else {
          this.$message({
            message: "加载失败！",
            type: "error",
          });
        }
      });
    },
    //下载照片
    handleImages(id,picType) {
      const data = {
        outboundID: id,
        picType:picType
      };

      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios
        .get(getOutboundReviewImagesFileOut, {
          params: data,
        })
        .then((res) => {
          loading.close();
          if (res.data.success) {
            var data = res.data.response;
            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    //打印拣货单查询
    printPickList() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }

      getOutboundOrderPrint({ outboundID: row[0].tfOutboundID }).then((res) => {
        if (res.data.success) {
          this.printPickListVisible = true;
          this.boxPrint = res.data.response.outbountDetailList;
          this.outbountPrint = res.data.response;
          this.$nextTick(() => {
            JsBarcode("#barcode1", this.outbountPrint.outboundNo, {
              format: "CODE128", //条形码的格式
              font: "-apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', 'miui', 'Hiragino Sans GB', 'Microsoft Yahei', sans-serif",
              displayValue: true,
              width: 2, //线宽
              height: 90, //条码高度
              lineColor: "#000", //线条颜色
              displayValue: true, //是否显示文字
              margin: 2, //设置条形码周围的空白区域
            });
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //打印拣货单
    printPick() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      var that = this;
      outboundOrderStatusPrint({ outboundID: row[0].tfOutboundID }).then(
        (res) => {
          if (res.data.success) {
            this.initTable();
            this.printPickListVisible = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        }
      );
    },
    //打印装车单查询
    printLoadList() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }

      getLoadInfoPrint({ tfOutboundID: row[0].tfOutboundID }).then((res) => {
        if (res.data.success) {
          this.printLoadListVisible = true;
          this.carBoxPrint = res.data.response.loadCarPrintList;
          this.carInfoPrint = res.data.response;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //打印装车单
    printLoadCar() {
      this.printLoadListVisible = false;
    },
    //加载基础资料
    getBasicdatalist() {
      let user = JSON.parse(window.localStorage.user);
      this.warehouseList = user.warehouseList;
      getReadyforTaskBasis("").then((res) => {
        this.transportList = res.data.response.transportdata;
        this.statuslist = this.formatterOption(
          res.data.response.outboundStatusdata,
          "outboundText",
          "outboundId"
        );
      });
    },
    formatterOption(option, labelKey, valueKey) {
      return (
        option &&
        option.map((item) => {
          item.label = item[labelKey];
          item.value = item[valueKey];
          return item;
        })
      );
    },

    pickingOverSubmit() {
      const that = this;
      console.info(that.pickingOverForm);
      if (
        that.pickingOverForm.Storages == null ||
        that.pickingOverForm.Storages == ""
      ) {
        this.$message({
          message: "请输入库位",
          type: "error",
        });
        return false;
      }
      const loading = this.$loading({
        lock: true,
        text: "请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      const data = {
        TFOutboundID: that.pickingOverForm.TFOutboundID,
        OutboundNo: that.pickingOverForm.OutboundNo,
        Storages: that.pickingOverForm.Storages.join(","),
      };

      outboundOverPicking(data).then((res) => {
        loading.close();
        if (res.status === 200 && res.success) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.pickingOverVisible = false;
          this.initTable();
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    pickingOver() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }

      if (this.selectRows.rows[0].outboundStatus != 20) {
        this.$message({
          message: "只有[拣货中]才允许操作,请确认！",
          type: "error",
        });
        return;
      }

      this.pickingOverForm = {
        TFOutboundID: row[0].tfOutboundID,
        OutboundNo: row[0].outboundNo,
        Storages: [],
      };
      this.pickingOverVisible = true;

      const para = {
        warehouseId: row[0].warehouseId,
        area: "",
      };
      getAreaLocation(para).then((res) => {
        if (res.data.success == true) {
          this.locationList = res.data.response;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
          return;
        }
      });
    },

    pallet() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }

      this.addForm = {
        OutboundNo: row[0].outboundNo,
        SourceId: row[0].tfOutboundID,
        BoxCount: "",
        PalletQty: 1,
        Storages: "",
        PalletBoxCount: row[0].palletBoxCount,
      };
      this.addFormVisible = true;
      this.addLoading = false;
      const para = {
        warehouseId: row[0].warehouseId,
        area: "",
      };
      getAreaLocation(para).then((res) => {
        if (res.data.success == true) {
          this.locationList = res.data.response;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
          return;
        }
      });
    },

    //打托
    onAddSubmit() {
      let para = Object.assign({}, this.addForm);
      console.log(para);
      let _this = this;

      this.$refs.addRuleForm.validate((valid) => {
        if (valid) {
          var user = JSON.parse(window.localStorage.user);
          if (!user && user.id == 0) {
            this.$message({
              message: "用户信息为空，先登录",
              type: "error",
            });
            _this.$router.replace(
              _this.$route.query.redirect ? _this.$route.query.redirect : "/"
            );
          }

          this.addLoading = true;
          addTFPallet(para).then((res) => {
            this.addLoading = false;
            console.log(res);
            if (res.data.success) {
              this.addFormVisible = false;
              this.$refs["addRuleForm"].resetFields();
              this.initTable();
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    let user = JSON.parse(window.localStorage.user);
    this.organizationList = user.organizationList;
    console.log(this.buttonList);
    this.getBasicdatalist();
    getOperatorInfo().then((res) => {
      this.userList = res.data.response;
    });
  },
};
</script>
<style lang="less">
.content-az {
  overflow-x: hidden;
}
.printDalog {
  .el-dialog__body {
    padding-top: 0;
  }
}
.printRow {
  position: absolute;
  right: 20px;
}
.dialogClass {
  .el-dialog {
    .el-dialog__body {
      //border-top: 1px solid #dcdfe6;
      //border-bottom: 1px solid #dcdfe6;
      max-height: 2000px !important;
      min-height: 500px;
      overflow-y: hidden;
    }
  }
  .el-dialog.is-fullscreen {
    max-height: 2000px !important;
    min-height: 500px;
  }
}
.printList {
  font-size: 16px;
  margin-bottom: 14px;
}
#completeDivd {
  font-size: 16px;
  width: 80%;
  margin: 0 auto;
}
</style>


<style>
figure {
  page-break-inside: avoid;
}
.viewer-list > li {
  width: 80px;
}
.viewer {
  display: none;
}
</style>